import { IsNotEmpty } from "class-validator";

export class AdapterCrewPersonDto {
  //
  @IsNotEmpty()
  crew_id: string;

  @IsNotEmpty()
  availability_header_id: string;
}
